import * as __WEBPACK_EXTERNAL_MODULE__shared_tokens_js_f588f438__ from "../shared/tokens.js";
const displayValues = [
    'none',
    'inline-flex',
    'flex'
];
const directionValues = [
    'row',
    'column',
    'row-reverse',
    'column-reverse'
];
const alignValues = [
    'start',
    'center',
    'end',
    'baseline',
    'stretch'
];
const justifyValues = [
    'start',
    'center',
    'end',
    'between'
];
const wrapValues = [
    'nowrap',
    'wrap',
    'wrap-reverse'
];
const gapValues = __WEBPACK_EXTERNAL_MODULE__shared_tokens_js_f588f438__.spacing;
export { alignValues, directionValues, displayValues, gapValues, justifyValues, wrapValues };

//# sourceMappingURL=flex.prop.js.map